import script from "./MandateEmailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./MandateEmailModal.vue?vue&type=script&setup=true&lang=js"

import "./MandateEmailModal.vue?vue&type=style&index=0&id=09be243f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09be243f"]])

export default __exports__